import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, GridColumn, GridToolbar, } from "@progress/kendo-react-grid";
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Button } from "@progress/kendo-react-buttons";
import {
  createPrnd,
  deletePrnd,
  updatePrnd,
  importPrnd
} from '../../actions/index.js'
import Dialog from '../../components/Dialog/Dialog';
import EditPrndForm from '../../components/EditPrndForm.jsx';
import { process } from '@progress/kendo-data-query';
import { CheckmarkCell, DateCell, EditCommandCell, GroupCell } from '../../components/GridCell'
import { formCloser } from '../../utils/formCloser.js';
import { esriSuggest } from '../../actions/portal/esri/esriSuggest.js';

const initialDataState = {
  skip: 0,
  take: 10,
  // sort: [
  //   { field: 'lastName', dir: 'asc' }
  // ],
}

const DashboardPRND = () => {
  const _export = React.useRef(null);

  const { token, user } = useSelector(state => state.authReducer);
  const { prnd } = useSelector(state => state.prndReducer)
  const { esriSuggestions } = useSelector(state => state.esriReducer);
  const { groups } = useSelector(state => state.groupsReducer);
  const { userFilter } = useSelector(state => state.filterReducer);

  const [openForm, setOpenForm] = useState(false);
  const [dataState, setDataState] = useState(initialDataState);
  const [dialogProps, setDialogProps] = useState({});
  const [searchInput, setSearchInput] = useState('');
  const [selectedPrnd, setSelectedPrnd] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [showSearchClearBtn, setShowSearchClearBtn] = useState(false);
  const [addressVal, setAddressVal] = useState('');

  const inputFileRef = React.useRef();

  const dispatch = useDispatch();

  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  const importCSV = (e) => {
    if (e?.target?.files) {
      dispatch(importPrnd(e.target.files[0], token))
    }
  }

  const enterEdit = (item) => {
    setOpenForm(true);
    setSelectedPrnd(item);
  }

  const addressHandler = (e) => {
    dispatch(esriSuggest(e.value, token))
  }

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const deleteEntry = (dataItem) => {
    // prompt for confirmation
    setDialogProps({
      title: `Delete PRND`,
      text: `Are you sure you want to delete this record?`,
      onConfirm: () => {
        dispatch(deletePrnd(dataItem.id, token, formCloser(setShowDialog)))
      },
      enableCancelBtn: true
    });

    setShowDialog(true);
  }


  const editFormSubmit = (event) => {
    if (!event.id) {
      dispatch(createPrnd(event, token, formCloser(setOpenForm)));
    } else {
      let prndData = {
        "region": event.region,
        "address": event.address,
        "capabilities": event.capabilities,
        "quantity": event.quantity,
        "city": event.city,
        "county": event.county,
        "location": event.location,
        "manufacturer": event.manufacturer,
        "mission": event.mission,
        "model": event.model,
        "poc1Name": event.poc1Name,
        "poc1Phone": event.poc1Phone,
        "poc2Name": event.poc2Name,
        "poc2Phone": event.poc2Phone,
        "serialNo": event.serialNo,
        "state": event.state
      }
      dispatch(updatePrnd(event.id, prndData, token, formCloser(setOpenForm)))
    }
  }

  return (
    <div>
      <ExcelExport ref={_export} data={prnd}>
        <Grid
          {...dataState}
          data={process(prnd, dataState)}
          onDataStateChange={e => setDataState(e.dataState)}
          pageable={true}
          sortable={true}
          className='flo-prnd-grid'
        >
          <GridToolbar>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                {!user.viewOnly && !user.notificationOnly ? <Button
                  className="k-button k-primary"
                  style={{
                    minHeight: 25,
                    padding: '10px 20px',
                    marginLeft: 15,
                  }}
                  onClick={() => {
                    enterEdit({
                      email: "",
                      first_name: "",
                      last_name: "",
                      admin: false,
                      enabled: true,
                      canOnlySeeGroupContacts: true,
                      password: ""
                    })
                  }}
                  iconClass="k-icon k-i-plus"
                >
                  Create Record
                </Button> : null}
                {!user.viewOnly && !user.notificationOnly ? <>
                  <input
                    type="file"
                    ref={inputFileRef}
                    style={{ display: 'none' }}
                    accept=".csv"
                    onChangeCapture={(e) => importCSV(e)}
                  />
                  <Button
                    className="k-button k-primary"
                    style={{
                      minHeight: 25,
                      padding: '10px 20px',
                      marginLeft: 15,
                    }}
                    onClick={() => {
                      inputFileRef.current.click();
                    }}
                    iconClass="k-icon k-i-file-csv"
                  >
                    Import CSV
                  </Button></> : null}
              </div>
            </div>
          </GridToolbar>
          <GridColumn field="region" title="Region" />
          <GridColumn field="address" title="Address" />
          <GridColumn field="capabilities" title="Capabilities" />
          <GridColumn field="quantity" title="Quantity" />
          <GridColumn field="city" title="City" />
          <GridColumn field="county" title="County" />
          <GridColumn field="location" title="Location" />
          <GridColumn field="model" title="Model" />
          <GridColumn field="poc1Name" title="Primary POC Name" />
          <GridColumn field="poc1Phone" title="Primary POC Phone" />
          <GridColumn field="state" title="State" />
          <GridColumn
            cell={(props) => (
              <EditCommandCell
                {...props}
                user={user}
                enterEdit={enterEdit}
                deleteEntry={(dataItem) => deleteEntry(dataItem)}
              />
            )}
            width={100}
          />
        </Grid>
      </ExcelExport>
      {openForm && (
        <EditPrndForm
          groups={groups}
          addressVal={addressVal}
          addressHandler={addressHandler}
          addressDataSource={esriSuggestions}
          cancelEdit={handleCancelEdit}
          onSubmit={editFormSubmit}
          item={selectedPrnd}
        />
      )}
      {showDialog &&
        <Dialog
          {...dialogProps}
          onClose={() => setShowDialog(false)}
        />}
    </div>
  )
}

export default DashboardPRND;